
import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "./ui/dialog";
import { Button } from "./ui/button";
import UserForm from "./UserForm";
import { z } from "zod";
import { UserFormSchema } from "@/schemas/user-form.schema";
import { addUser } from "@/services/users.service";
import { UserSchema } from "@/schemas/user.schema";

interface Props {
    onAddSuccess?: (user: z.infer<typeof UserSchema>) => void
}


export default function AddUserModal(props: Props) {
    const [open, setOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const handleOnSubmit = async (data: z.infer<typeof UserFormSchema>) => {
        try {
            setIsLoading(true);
            const user = await addUser(data);
            handleSuccess(user);
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    }

    const handleSuccess = (user: z.infer<typeof UserSchema>) => {
        setIsLoading(false);
        setOpen(false);
        props.onAddSuccess?.(user);
    }

    return <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
            <Button>Add user</Button>
        </DialogTrigger>
        <DialogContent className="max-w-sm">
            <DialogTitle>Add user</DialogTitle>
            <UserForm onSubmit={handleOnSubmit} isLoading={isLoading} />
        </DialogContent>
    </Dialog>
}